import PropTypes from 'prop-types';
import React from 'react';
import ModalBase from '@molecules/ModalBase';
import { BodyLarge, H2 } from '@react/styledComponents';

const SportsWaiverModal = ({ isOpen, onClose }) => {
    return (
        <ModalBase
            isOpen={isOpen}
            stylesBody={{
                paddingBottom: '64px',
                paddingLeft: '64px',
                paddingRight: '64px',
                paddingTop: '24px',
            }}
            onClose={onClose}
        >
            <H2>Release and Waiver of Claims</H2>
            <BodyLarge className="mt-1.875rem">
                I hereby agree and acknowledge that I am participating in the foregoing ICSC Event and related
                activities on my own accord. I give this acknowledgment freely and knowingly and I represent and warrant
                to ICSC that I am physically and mentally fit and that, as a result, able to participate in the Event
                and related activities, and I do hereby assume responsibility for my own well-being at the Event and
                related activities.
                <br />
                <br />
                I AM AWARE AND UNDERSTAND THAT THE EVENT AND RELATED ACTIVITIES MAY BE DANGEROUS AND/OR INVOLVE THE RISK
                OF SERIOUS INJURY AND/OR DEATH AND/OR PROPERTY DAMAGE. I ACKNOWLEDGE THAT ANY INJURIES THAT I SUSTAIN
                MAY BE COMPOUNDED BY NEGLIGENT EMERGENCY RESPONSE OR RESCUE OPERATIONS OF THE COMPANY. I ACKNOWLEDGE
                THAT I AM VOLUNTARILY PARTICIPATING IN THE ACTIVITIES WITH KNOWLEDGE OF THE DANGER INVOLVED AND HEREBY
                AGREE TO ACCEPT AND ASSUME ANY AND ALL RISKS OF INJURY, DEATH OR PROPERTY DAMAGE, WHETHER CAUSED BY THE
                NEGLIGENCE OF ICSC OR OTHERWISE.
                <br />
                <br />
                In consideration of the right to participate in this Event and related activities, I hereby expressly
                waive any and all rights or claims I may have as a result of participation in this Event against the
                International Council of Shopping Centers, Inc., and its affiliates, and their respective directors,
                officers, employees, members, staff, and all individuals assisting in instructing, sponsoring and
                conducting these activities, and I hereby fully release and discharge them from any and all claims
                resulting from injuries, including death, damages or loss, which may accrue to me or my heirs arising
                out of or in any way connected with my participation in the Event and related activities.
                <br />
                <br />
                I further agree to indemnify, defend and hold harmless the International Council of Shopping Centers,
                Inc., its affiliates, and their respective directors, officers, employees, members, staff, and all
                individuals assisting in instructing, sponsoring and conducting these activities, from any and all
                claims resulting from injuries, including death, damages or loss, which may accrue to me or my heirs
                arising out of or in any way connected with my participation in this Event and related activities.
                <br />
                <br />
                I hereby agree that this Release and Waiver shall be binding upon and enforceable against me, my
                personal representatives, spouse, assigns, heirs and next of kin without limitation. It is my desire and
                intent that the words, terms, provisions, covenants, and remedies contained in this Release and Waiver
                shall be enforceable to the fullest extent permitted by law. If any portion of this Release and Waiver
                is held invalid, the remainder shall not be affected and shall continue in full legal force and effect.
                That shall include modifying the Release and Waiver to allow any remaining claims to be waived,
                released, and indemnified against in the event that the inclusion of any particular provision is found
                to be invalid or contrary to public policy. The terms of this Release and Waiver shall continue from
                this date forever. This document constitutes the entire agreement between me and ICSC and supersedes any
                previous or contemporaneous discussions or agreements between us in respect of these matters.
                <br />
                <br />
                The formation, enforcement, construction, performance, amendment and termination of this Agreement and
                the Parties' relationship in connection therewith, including the resolution of any related disputes or
                claims, whether sounding in contract, tort or otherwise, shall be governed, construed and enforced in
                all respects in accordance with the laws of the State of New York, without regard to its choice of laws
                provisions, and any suit, action or proceeding arising out of or relating to this Agreement shall be
                brought only in the courts, whether state or federal, located in the State of New York. Each Party
                hereby agrees to personal jurisdiction in any such suit, action or proceeding.
                <br />
                <br />
                ACKNOWLEDGEMENT AND CONSENT TO RELEASE AND WAIVER BY SUBMITTING THIS COMPLETED EVENT REGISTRATION FORM
                TO ICSC, I HEREBY ACKNOWLEDGE THAT I HAVE READ, UNDERSTOOD, AND AGREE TO ALL OF THE TERMS OF THIS
                RELEASE AND WAIVER.
                <br />
                <br />
                NOTE: Registrants that fail to complete the foregoing Acknowledgement and Consent to Release and Waiver
                shall not be permitted to participate in the applicable Event activities.
            </BodyLarge>
        </ModalBase>
    );
};

SportsWaiverModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default SportsWaiverModal;
